module.exports = __webpack_public_path__ + "img/star3red.2dd11e32.png";